import { FundoFixo } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from './alert.service';
import {environment} from '../../environments/environment'


@Injectable({
    providedIn: 'root'
})

export class FundoFixoService {

    GetRetornarFundoFixo(empresa: string): Observable<any> {
        return this.http.get<FundoFixo[]>(`${environment.apiUrl}/api/RetornaFundoFixo?empresa=${empresa}`);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }


}
